module.exports = __webpack_public_path__ + "static/media/bh.888cc21c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bh.svg
// module id = 2047
// module chunks = 0